import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import routeConstant from "../lib/constants/routeConstant";

const AuthenticationRoutes = () => {
    // Handle User SignedIn
    const { isSignedIn } = useSelector(state => state.user)

    return (
        // Check if user is signed in, navigate to Default Page else render the child routes (Outlet)
        isSignedIn ? <Navigate to={routeConstant.MY_ACCOUNT_PAGE} replace /> : <Outlet />
    );
};

export default AuthenticationRoutes;
